import React from 'react';
import MessagingLayout from '../components/messaging/MessagingLayout';

export default function Messages() {
  return <MessagingLayout />;
}



